module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/promise_05_sp-48548292627b1683af9a16c75f88b3e9.png";